var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFitnessIcon = function SvgFitnessIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53.942,
    height: 33.053,
    viewBox: "0 0 53.942 33.053",
    fill: "#FFF",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M896.886,665.854a10.444,10.444,0,0,0-3.936.536c-.815-1.807-1.769-3.924-2.884-6.406l.711-1.958,1.444-.027a1.139,1.139,0,0,0,1.058-1.1,1.121,1.121,0,0,0-1.065-1.093h-7.107a1.081,1.081,0,0,0-1.026,1.111v.021a.985.985,0,0,0,1.026,1h3.2l-.709,2.129H869.5c1.143-3.9.625-4.149,5.02-4.122a1.01,1.01,0,0,0,1.041-1v-.021a1.035,1.035,0,0,0-1.038-1.031c-6.448.019-5.441-.158-9.314,12.3a10.467,10.467,0,1,0,2.173.656c.228-.717.473-1.481.736-2.3,15.312,16.152,9.567,13.533,17.807,13.86.039,0,.077,0,.116,0a10.468,10.468,0,1,0,10.843-12.552m-25.578,10.624a8.026,8.026,0,1,1-6.845-7.931c-2.555,8.055-2.249,7.137-2.263,7.817a1.068,1.068,0,0,0,1.031,1.066c1.043-.105.807.067,3.411-8.233a8.024,8.024,0,0,1,4.666,7.28m10.335-.555L868.793,662.2h18.1Zm4.19.347-1.948-.006L888.937,663l1.96,4.343a10.473,10.473,0,0,0-5.064,8.926m6.082-6.673,3.023,6.7-6.658-.018a8.022,8.022,0,0,1,3.635-6.68m4.383,14.728a8.032,8.032,0,0,1-7.74-5.926c8.345.007,9.089.435,9.206-1.013-.012-.421-.167-.711-3.8-8.748a8.018,8.018,0,1,1,2.334,15.688",
    transform: "translate(-852.823 -653.891)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFitnessIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fitness-icon.59e06734.svg";
export { ForwardRef as ReactComponent };